import graph from "@irati/utils/services/graph"
import {question} from "./question"
import {driver} from "./driver"


const service = {}

export const userSurvey = `
  Etag
  commentCount
  createdAt
  id
  preferences {
    actionBoardUrl
    driverCommentTitle
    includeActionBoard
    includeDriverComment
  }
  questions {
     ${question}
  }
  status
  submittedAnswers{
    questionId
    text
    time
    value
  }
  submittedAt
  submittedDriverComments{
    driverId
    text
  }
  surveyId
  teams
  test
  surveyInfo(tenant: $tenant) {
    tenant
    status
  }
  drivers(tenant: $tenant) {
    results{
      ${driver}
    }
  }
`
service.get = (id, tenant, variables, options = {}) => {
  const query = `
  query UserSurvey (
    $id: String!,
    $tenant: String!,
    $withQuestionDriver: Boolean = false
  ) {
    userSurvey (
      id: $id,
      tenant: $tenant,
  ) {
      ${userSurvey}
    }
  }
  `
  return graph({query, variables: {id, tenant, ...variables}}, {unAuth: true, ...options})
    .then((response) => response.userSurvey)
}


service.list = (tenant, variables, options = {}) => {
  const query = `
  query UserSurveys (
    $tenant: String!,
    $scheduleId: String,
    $status: String,
    $minCommentCount: Int,
    $orderBy: String,
    $orderDirection: String,
    $test: Int,
    $teamId: String,
    $minOpenedAt: String,
    $withQuestionDriver: Boolean = false
  ) {
    userSurveys (
      tenant: $tenant,
      scheduleId: $scheduleId,
      status : $status,
      minCommentCount: $minCommentCount,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      test: $test,
      team: $teamId,
      minOpenedAt: $minOpenedAt
  ) {
      results {
        ${userSurvey}
      }
    }
  }
  `
  return graph({query, variables: {tenant, ...variables}}, {unAuth: true, ...options})
    .then((response) => response.userSurveys.results)
}

export const getUserSurvey = service.get
export const getUserSurveys = service.list
